module.exports = __webpack_public_path__ + "assets/crowdin-dark-symbol.90e466be.png";